import styled, { css } from 'styled-components';

export const StyledMeetingAction = styled.button<{
  $isDecline?: boolean;
  $isSelected?: boolean;
  $isDisabled?: boolean;
}>`
  cursor: pointer;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #18212c;
  border: none;
  ${({ $isDecline }) =>
    $isDecline &&
    css`
      background-color: #ff4c4e;
    `}
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: #ffffff;
    `}
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.6;
      cursor: default;
    `}
`;
